import { render } from "./MultiSelect.vue?vue&type=template&id=12400a32&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"

import "./MultiSelect.vue?vue&type=style&index=0&id=12400a32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12400a32"

export default script